import { type AbilityClass, type ForcedSubject, PureAbility, type SubjectRawRule } from '@casl/ability';
import type { PrismaQuery } from '@casl/prisma';

export const allActions = ['manage', 'create', 'read', 'update', 'delete', 'view', 'SetupsSuperAdmin'];
export const allModels = [
  'All',
  'AuditLog',
  'User',
  'Local',
  'Equipment',
  'Company',
  'Supplier',
  'Tutorial',
  'Plan',
  'PlanSubscription',
  'StandardEquipment',
  'Call',
  'PeriodicalFee',
  'Module',
  'Periodicity',
  'Maintenance',
  'MaintenancePlanItem',
  'CompanyPlanSelection',
  'Settings',
  'uiRole',
  'PlanModule',
  'WAMessage',
  'Start',
  'Stock',
  'StockItem',
  'StockMovimentation',
  'Warehouse',
  'Notification',
  'WasteContainer',
  'WasteType',
  'WasteInspection',
  'WasteCollection',
  'WasteGeneration',
  'WasteMedition',
  'WasteGlobalAlerts',
  'FuelGaseClass',
  'FuelGaseContainer',
  'FuelGaseMovimentation',
  'FuelGaseInspection',
  'multiBuildingComplexes'
];
export const modulesKey = [
  'start',
  'stock',
  'wa',
  'sms',
  'verde-acqua',
  'verde-acqua-individualized-readings',
  'verde-acqua-ocr',
  'verde-acqua-gas',
  'verde-acqua-electricity'
];

export const allRoles = [
  'superadmin',
  'admin',
  'manager',
  'supervisor',
  'collaborator',
  'provider',
  'auditor',
  'guest'
];
export type Actions = (typeof allActions)[number];
export type AppSubjects = (typeof allSubjects)[number];
export type Roles = (typeof allRoles)[number];

export const allUISubjects = ['UIRole', ...modulesKey];
export const allSubjects = [...allModels, ...allUISubjects];

export type AppAbility = PureAbility<[string, AppSubjects | ForcedSubject<AppSubjects>], PrismaQuery>;
export const AppAbility = PureAbility as AbilityClass<AppAbility>;

export type Rule = SubjectRawRule<Actions, AppSubjects, unknown>;
export type Rules = [Actions, AppSubjects, unknown?];
export type RoleWithRules = {
  name: string;
  rules: Rules[];
};

export type RolesWithRules = RoleWithRules[];
